import { useFormik } from "formik";
import { addLookup, editLookup } from "../../../API/services/utilities";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../../auth/formikValidation";
import Button from "../../sharedComponents/buttons/button";
import TextInput from "../../sharedComponents/inputs/textInput";
import Switch from "../../sharedComponents/switch/switch";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Lang from "../../../userPreferences/staticWords";

const AddLookupForm = ({
  isEdit,
  selectedLookup,
  setModalVisible,
  modalVisible,
  userToken,
}) => {
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);

  const submit = async (data) => {
    values.lookupName = selectedLookup;
    if (isEdit) values.id = modalVisible?.helperData?.data?.id;
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = isEdit
      ? await editLookup(values, userToken)
      : await addLookup(values, userToken);
    if (res.status <= 206) {
      dispatch({ type: "RELOAD" });
      setModalVisible({
        ...modalVisible,
        addLookup: false,
        editLookup: false,
        helperData: null,
      });
      setDisable(false);
    } else {
      setDisable(false);
    }
  };
  const formik = useFormik(
    formikSetup(
      initialValues,
      isEdit ? modalVisible?.helperData?.data : {},
      validationSchema,
      "addLookup",
      submit
    )
  );

  const { errors, touched, handleSubmit, handleChange, setFieldValue, values } =
    formik;
  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex flex-wrap justify-content-center align-content-center mb-3 h-100">
        <TextInput
          type={"text"}
          value={values.name_A}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "name_A")}
          name={"name_A"}
          placeholder={"الاسم بالعربي" + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
        ></TextInput>
        <TextInput
          style={{ textAlign: "left" }}
          type={"text"}
          direction={"ltr"}
          value={values.name_E}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "name_E")}
          name={"name_E"}
          placeholder={"الاسم بالانجليزية" + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
        ></TextInput>
        <TextInput
          type={"text"}
          value={values.description_A}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "description_A")}
          name={"description_A"}
          placeholder={"الوصف بالعربي" + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
        ></TextInput>
        <TextInput
          style={{ textAlign: "left" }}
          type={"text"}
          direction={"ltr"}
          value={values.description_E}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "description_E")}
          name={"description_E"}
          placeholder={"الوصف بالانجليزية" + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
        ></TextInput>
        <TextInput
          style={{ textAlign: "left" }}
          type={"text"}
          direction={"ltr"}
          value={values.color}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "color")}
          name={"color"}
          placeholder={"اللون " + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
        ></TextInput>
        <TextInput
          type={"number"}
          value={values.sortIndex}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "sortIndex")}
          name={"sortIndex"}
          placeholder={"الترتيب" + "*"}
          containerStyle={"col-12  col-md-5 mx-1 mt-4"}
          min={0}
        ></TextInput>
        <div className="col-12  col-md-10 mx-1 mt-4 d-flex justify-content-center">
          <div className="col-4   mt-4 d-flex align-items-center justify-content-center">
            <div className="mx-2">isDefault</div>
            <Switch
              checked={values.isDefault}
              name={"isDefault"}
              onClick={() => {
                setFieldValue("isDefault", !!!values.isDefault);
              }}
            />
          </div>
          <div className="col-4 mt-4 d-flex align-items-center justify-content-center">
            <div className="mx-2">focus</div>
            <Switch
              checked={values.focus}
              name={"focus"}
              onClick={() => {
                setFieldValue("focus", !!!values.focus);
              }}
            />
          </div>
          <div className="col-4 mt-4 d-flex align-items-center justify-content-center">
            <div className="mx-2">active</div>
            <Switch
              checked={values.active}
              name={"active"}
              onClick={() => {
                setFieldValue("active", !!!values.active);
              }}
            />
          </div>
        </div>
        <Button
          inputStyle={"solid"}
          type={"submit"}
          disable={disable}
          content={disable ? Lang.saving : Lang.save}
          containerStyle={"col-6 col-lg-3 mt-4"}
        />
      </div>
    </form>
  );
};

export default AddLookupForm;
